import { useReducedMotion } from '@/hooks/useReducedMotion';

interface Props {
  src: string;
  fallback: string;
  caption?: string;
  className?: string;
}

// Video renders a looping WebP clip by default. When the OS prefers reduced
// motion, it renders the static fallback image instead. Used in help articles
// for end-to-end UI flows that are too costly to simulate.
export function Video({ src, fallback, caption, className }: Props): JSX.Element {
  const reduced = useReducedMotion();
  const containerCls =
    'rounded-lg border border-dash-border overflow-hidden bg-dash-bg ' +
    (className ?? '');
  return (
    <figure className={containerCls}>
      {reduced ? (
        <img src={fallback} alt={caption ?? ''} className="block w-full h-auto" />
      ) : (
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          className="block w-full h-auto"
          aria-label={caption ?? undefined}
        />
      )}
      {caption ? (
        <figcaption className="px-3 py-2 text-xs text-dash-secondary border-t border-dash-border">
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
